import { ArtefactType } from '@modules/common/types';

export const getArtefactTypeLabel = (
  artefactType: ArtefactType,
  isSearchToFeedEnabled: boolean,
) => {
  if (artefactType === ArtefactType.Search && isSearchToFeedEnabled) {
    return 'Feed';
  }

  return artefactType;
};
